'use client'

import {
  ResponsiveTypography as AscendResponsiveTypography,
  Typography as AscendTypography,
  Link as AscendLink,
  Divider as AscendDivider,
  Table as AscendTable,
  TableContainer as AscendTableContainer,
  TableRow as AscendTableRow,
  TableCell as AscendTableCell,
  TableHead as AscendTableHead,
  TableBody as AscendTableBody,
  Paper as AscendPaper,
} from '@achieve/ascend'

export {
  AscendResponsiveTypography,
  AscendTypography,
  AscendLink,
  AscendDivider,
  AscendTable,
  AscendTableContainer,
  AscendTableRow,
  AscendTableCell,
  AscendTableHead,
  AscendTableBody,
  AscendPaper,
}
